import { useState, useEffect } from 'react';
import { fetchClassesWithWork } from '../services/googleClassroom';

export const useClassroom = (accessToken) => {
    const [classes, setClasses] = useState([]);
    const [isLoadingClasses, setIsLoadingClasses] = useState(false);

    // Load classes when access token is available
    useEffect(() => {
        if (!accessToken) return;

        const loadClasses = async () => {
            setIsLoadingClasses(true);
            try {
                const coursesWithWork = await fetchClassesWithWork(accessToken);
                setClasses(coursesWithWork);
                localStorage.setItem("classes", JSON.stringify(coursesWithWork));
            } catch (err) {
                console.error("Failed to load classes:", err);
            } finally {
                setIsLoadingClasses(false);
            }
        };

        loadClasses();
    }, [accessToken]);

    // Auto-refresh classwork every 15 minutes
    useEffect(() => {
        if (!accessToken) return;

        const refreshInterval = setInterval(async () => {
            setIsLoadingClasses(true);
            try {
                const coursesWithWork = await fetchClassesWithWork(accessToken);
                setClasses(coursesWithWork);
                localStorage.setItem('classes', JSON.stringify(coursesWithWork));
                console.log('Classwork auto-refreshed');
            } catch (error) {
                console.error('Error auto-refreshing classwork:', error);
            } finally {
                setIsLoadingClasses(false);
            }
        }, 15 * 60 * 1000);

        return () => clearInterval(refreshInterval);
    }, [accessToken]);

    const refreshClasswork = async () => {
        if (!accessToken) {
            alert("You need to be logged in to refresh!");
            return;
        }

        setIsLoadingClasses(true);
        try {
            const coursesWithWork = await fetchClassesWithWork(accessToken);
            setClasses(coursesWithWork);
            localStorage.setItem('classes', JSON.stringify(coursesWithWork));
        } catch (error) {
            console.error('Error refreshing:', error);
        } finally {
            setIsLoadingClasses(false);
        }
    };

    return { classes, isLoadingClasses, refreshClasswork };
};